/* eslint-disable sort-keys */
import React from 'react';

import { getDefaultStore, Provider } from 'jotai';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { appVariantAtom } from '@consumer-frontend/nc-components';
import { useBfcacheReload } from '@consumer-frontend/nc-utils';

const store = getDefaultStore();

store.set(appVariantAtom, 'apply');

export type AppPropsT = {
  router: ReturnType<typeof createBrowserRouter>;
};

export const App: React.FC<AppPropsT> = ({
  router,
}) => {
  useBfcacheReload();

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};
